import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
    apiKey: "AIzaSyD0TZ86TEu96-k4iY8zS7rA55AM0KNLHUY",
    authDomain: "welcome-to-sde-nehemia.firebaseapp.com",
    projectId: "welcome-to-sde-nehemia",
    storageBucket: "welcome-to-sde-nehemia.appspot.com",
    messagingSenderId: "336308199243",
    appId: "1:336308199243:web:6108d38b9fe930ab15d2ce"
  };

  initializeApp(firebaseConfig)

  const db = getFirestore()
  const auth = getAuth()

  export {auth, db}